/** @jsx jsx */
import { FC } from "react";
import { CompositeItem } from "reakit/Composite";
import { jsx } from "theme-ui";

import { TimeReportCalendarCellBackground } from "./TimeReportCalendarCellBackground";
import { useTimeReportCalendarGrid } from "./TimeReportCalendarGridContext";

interface TimeReportCalendarRowHeaderCellProps {
  background?: TimeReportCalendarCellBackground;
}

export const TimeReportCalendarRowHeaderCell: FC<TimeReportCalendarRowHeaderCellProps> = ({
  children,
  background = "none",
  ...restProps
}) => {
  const { compositeState } = useTimeReportCalendarGrid();

  return (
    <CompositeItem
      {...compositeState}
      {...restProps}
      as="div"
      role="columnheader"
      sx={{
        display: "table-cell",
        px: 16,
        py: 10,
        border: t => `1px solid ${t.colors?.n200}`,
        backgroundColor: background,
      }}>
      {children}
    </CompositeItem>
  );
};
